export default {"src":"/_next/static/media/not-found.da438085.svg","height":366,"width":528,"blurWidth":0,"blurHeight":0};